import { Row, Typography } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import React, { useMemo } from "react";
import { formatNumber } from "src/utils/formatting";

const { Text } = Typography;

interface FillLevelTagProps {
    grainHeightCenterFt: number | null;
    grainHeightPerimeterFt: number | null;
    estimatedBushels: number | null;
    fillLevelPercent: number | null; 
    onClick: () => void;
}

const FillLevelTag : React.FC<FillLevelTagProps> = ({ grainHeightCenterFt, grainHeightPerimeterFt, estimatedBushels, fillLevelPercent, onClick }) => {


    const tagStyle = {
        backgroundColor: '#f5f5f5',
        border: '2px solid black',
        borderRadius: '999px',
        borderColor: '#000000',
    }
    
    const tagTextStyle = {
        padding: '2px 12px',
        fontSize: '13px',
        fontFamily: 'monospace',
        fontWeight: 'bold',
        color:'#000000',
        whiteSpace: 'nowrap',
    }

    const displayGrainHeightCenter = useMemo( () => {
        return formatNumber(grainHeightCenterFt, { decimalPlaces: 1, showSuffixIfNoValue: true, suffix: `'c` });
    }, [grainHeightCenterFt]);

    const displayGrainHeightPerimeter = useMemo( () => {
        return formatNumber(grainHeightPerimeterFt, { decimalPlaces: 1, showSuffixIfNoValue: true, suffix: `'p` });
    }, [grainHeightPerimeterFt]);

    const displayEstimatedBushels = useMemo( () => {
        return formatNumber(estimatedBushels, { decimalPlaces: 0, showSuffixIfNoValue: true, suffix: `bu` });
    }, [estimatedBushels]);

    const displayFillLevelPercent = useMemo( () => {
        return formatNumber(fillLevelPercent, { decimalPlaces:1, showSuffixIfNoValue: true, suffix: `%` });
    }, [fillLevelPercent]);

    return(
        <div onClick={onClick}>
            <Row>
                <Text>Fill Level <InfoCircleOutlined /></Text>
            </Row>
            <Row style={tagStyle}>
                <Text style={tagTextStyle}>{displayGrainHeightCenter} | {displayGrainHeightPerimeter} | {displayEstimatedBushels} | {displayFillLevelPercent} </Text>
            </Row>
        </div>
    )
}

export default FillLevelTag;